import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/reportSlice";
import reportApis from "src/api/report";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* RunReportSaga({
  payload,
}: ReturnType<typeof actions.runReportRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      reportApis.runReport,
      payload
    );
    yield put(actions.runReportSuccess(response));
  } catch (error) {
    yield put(
      actions.runReportError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* reportSaga() {
  yield all([takeEvery(actions.runReportRequest, RunReportSaga)]);
}
